module.exports = __webpack_public_path__ + "img/Swift 2.7fde9660.svg";